import { Component, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { Subscription, TeardownLogic, timer } from 'rxjs';
import { AuthService, VERSION_NUMBER } from '../../services';


@Component({
    selector: 'app-offline',
    templateUrl: './offline.component.html',
    styleUrls: ['./offline.component.scss'],
})
export class OfflineComponent implements OnDestroy {
    private _subrelease = new Subscription();
    set subrelease(sub: TeardownLogic) {
        this._subrelease.add(sub);
    }

    ShowingUpdate = false;
    readonly TimerMax = 60;
    TimerCount = this.TimerMax;

    constructor(private authSvc: AuthService, private titleSvc: Title) {
        this.titleSvc.setTitle('Multiple Pathways | System Current Unavailable');

        // Set up a subscription on Test Connection, to check for the system being available while waiting for it to resume.
        // If the user isn't logged in and we detect a new version is available, silently go ahead and reload.
        this.subrelease = timer(0, 1000).subscribe((_) => {
            this.TimerCount--;

            if (this.TimerCount === 0) {
                // Call out to test the connection.
                this.authSvc.TestConnection().subscribe(
                    (result) => {
                        // Update the status.
                        this.authSvc.SetSystemOnlineStatus(result);

                        // And reset the tick count.
                        this.TimerCount = this.TimerMax;
                    },
                    (err) => {
                        this.authSvc.SetSystemOnlineStatus({
                            Status: false,
                            SystemMessage: '',
                            PathwaysVersion: VERSION_NUMBER,
                        });
                    }
                );
            }
        });
    }

    ngOnDestroy(): void {
        this._subrelease.unsubscribe();
    }
}